//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios';
import { get, post } from '@/api/fetch.js';
import url from '@/api/serviceAPI.config.js';
import { encrypt, decrypt } from '@/utils/RAS';
export default {
  data: function data() {
    return {
      param: {
        username: '',
        password: '',
        type: '1'
      },
      rules: {
        username: [{
          required: true,
          message: '请输入用户名',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }]
      },
      checked: false
    };
  },
  created: function created() {
    this.param.username = localStorage.getItem('account');
    this.param.password = decrypt(localStorage.getItem('password'));
    if (this.param.username || this.param.password) {
      this.checked = true;
    }
  },
  methods: {
    submitForm: function submitForm() {
      var _this = this;
      this.$refs.login.validate(function (valid) {
        if (valid) {
          // 创建实例时设置配置的默认值
          var instance = axios.create();
          // 在实例已创建后修改默认值
          instance.defaults.headers.post['Content-Type'] = 'application/json';
          _this.param.password = encrypt(_this.param.password); //原本密码加密
          instance.post(url.log.login, _this.param).then(function (res) {
            if (res.data.status == 400) {
              _this.$message.error('账号或者密码错误');
            } else {
              sessionStorage.setItem('account', res.data.username);
              sessionStorage.setItem('userId', res.data.id);
              _this.$router.push('/company');
              _this.$message({
                message: '登录成功',
                type: 'success'
              });
              if (_this.checked) {
                localStorage.setItem('account', _this.param.username);
                localStorage.setItem('password', _this.param.password);
              } else {
                localStorage.removeItem('account');
                localStorage.removeItem('password');
              }
            }
          }).catch(function (err) {
            if (err.response.status == 400) {
              _this.$message.error('账号或者密码错误');
            }
          });
        } else {
          _this.$message.error('请输入账号和密码');
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
};